import { render, staticRenderFns } from "./InvitationArticle.vue?vue&type=template&id=4fb05469&scoped=true&"
import script from "./InvitationArticle.vue?vue&type=script&lang=js&"
export * from "./InvitationArticle.vue?vue&type=script&lang=js&"
import style1 from "./InvitationArticle.vue?vue&type=style&index=1&id=4fb05469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb05469",
  null
  
)

export default component.exports